module.exports = __webpack_public_path__ + "img/recepcionista.e7d73245.jpg";